export function getAthleteLimitFromError(error: unknown): number | null {
  if (typeof error !== "object" || error === null || !("error" in error)) {
    return null;
  }

  const inner = (
    error as { error: { code?: string; athleteLimit?: number } | null }
  ).error;

  if (
    inner?.code === "ATHLETE_LIMIT_REACHED" &&
    typeof inner.athleteLimit === "number"
  ) {
    return inner.athleteLimit;
  }

  return null;
}
